import { drawDOM, exportPDF } from "@progress/kendo-drawing";
import { KendoDrawingAdapter } from "@progress/kendo-react-pdf";
import axios from "axios";
import { downloadDataUri, sanitizeDownloadFileName } from "../../utils/triggerDownload";

/** Kendo's default saveAs clicks a detached <a>, which often drops suggested filenames (e.g. Playwright UUIDs). */
function saveAsBodyAttached(dataUri, fileName) {
  downloadDataUri(dataUri, sanitizeDownloadFileName(fileName));
}

const base64Email = (from, to, body, setIsSending, fileName, nav) => {
    
    try {
        const token = sessionStorage.getItem('token');
        let gridElement = document.querySelector('#PDFExport');
        drawDOM(gridElement, {
            paperSize: "Letter",
            scale: 0.68,
            forcePageBreak: ".page-break",
            margin: { top: 15, right: 45, left: 45 }
        })
            .then((group) => {
                return exportPDF(group);
            })
            .then(async (dataUri) => {
                setIsSending(true)
                await axios.post(
                    //"http://localhost:8080/emailGenerator",
                    process.env.REACT_APP_EMAIL,
                    {
                        dataUri,
                        from: from,
                        to: to,
                        body: body,
                        fileName
                    },
                    {
                        headers: {
                            authorization: 'Bearer ' + token
                        }
                    })
                    .then(response => {
                        if (response.status === 200) {
                            alert(response.data)
                        }
                        setIsSending(false)
                    })
                    .catch((error) => {
                        setIsSending(false);
                        if (error.response?.status === 401) {
                            nav('/login');
                            return;
                        }
                        const msg =
                            error.response?.data ||
                            error.message ||
                            "Network error while sending email.";
                        alert(typeof msg === "string" ? msg : "Send Failed");
                    })
                
            })
    } catch (e) {
        setIsSending(false)
        console.log(e)
        alert(e)
    }
};

function pdfExport(container, fileNameBase) {
    const instance = container?.current;
    const domEl = instance?.rootElForPDF ?? document.querySelector("#PDFExport");
    if (!domEl) {
        console.warn("pdfExport: no PDF root element (ref or #PDFExport)");
        return;
    }

    let exportProps;
    if (instance && typeof instance.getOptions === "function") {
        exportProps = instance.getOptions();
    } else {
        const base = String(fileNameBase || "export").replace(/\.pdf$/i, "");
        exportProps = {
            paperSize: "Letter",
            scale: 0.68,
            forcePageBreak: ".page-break",
            margin: { top: 15, right: 45, left: 45 },
            fileName: `${base}.pdf`,
        };
    }

    if (!exportProps.fileName) {
        const base = String(fileNameBase || "export").replace(/\.pdf$/i, "");
        exportProps = { ...exportProps, fileName: `${base}.pdf` };
    }

    new KendoDrawingAdapter(drawDOM, exportPDF, saveAsBodyAttached, domEl, exportProps).savePDF();
}

export { base64Email, pdfExport }
